import { useEffect, useRef } from "react";

// `skipFirstRun` defaults to false so any call site that relies on this
// hook's first run to fetch its initial data (no separate mount effect of
// its own) keeps working unchanged. Pass `{ skipFirstRun: true }` only when
// the caller already has its own mount-time fetch, otherwise both fire on
// load with the same default filters - a duplicate request every time.
const useDebouncedEffect = (callback, deps, delay, { skipFirstRun = false } = {}) => {
  const handler = useRef();
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (handler.current) clearTimeout(handler.current);

    if (isFirstRun.current) {
      isFirstRun.current = false;
      if (skipFirstRun) return undefined;
    }

    handler.current = setTimeout(() => {
      callback();
    }, delay);

    return () => clearTimeout(handler.current);
  }, deps);
};

export default useDebouncedEffect
